<template>
  <div class="mmp-legend-card scroll-Container">
    <div class="mmp-legend-header" :class="{ 'mmp-legend-header--no-border': legendMinimized }">
      <span id="modifiedLayerName" class="capitalize mmp-legend-title">
        {{ modifiedName }}
      </span>
      <div class="mmp-legend-actions">
        <button
          id="minOrMaxLayerLegendElement"
          class="mmp-legend-btn"
          :title="legendMinimized ? 'Maximize Legend' : 'Minimize Legend'"
          @click="$emit(legendMinimized ? 'maximizeLegend' : 'minimizeLegend')"
        >
          <fa :icon="['fas', legendMinimized ? 'window-maximize' : 'window-minimize']" />
        </button>
        <button
          id="closeLayerLegendElement"
          class="mmp-legend-btn mmp-legend-btn--close"
          title="Close Legend"
          @click="$emit('closeLegend')"
        >
          <fa :icon="['fas', 'window-close']" />
        </button>
      </div>
    </div>
    <div class="mmp-legend-body" v-show="!legendMinimized">
      <img
        id="imgLegend"
        v-show="!legendMinimized"
        :src="legendImgSrc"
        @load="getDimensions()"
      />
    </div>
  </div>
</template>

<style scoped>
.mmp-legend-card {
  display: flex;
  flex-direction: column;
  max-height: 35vh;
  background: #ffffff;
  border: 1px solid rgba(6, 60, 109, 0.12);
  border-radius: 0.25rem;
  box-shadow: 0 4px 16px rgba(6, 60, 109, 0.2);
  overflow: hidden;
}

.mmp-legend-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex: 0 0 auto;
  padding: 6px 8px 6px 12px;
  background: linear-gradient(135deg, #ffffff 0%, #f3f8fc 100%);
  border-bottom: 1px solid rgba(6, 60, 109, 0.1);
}

.mmp-legend-header--no-border {
  border-bottom: none;
}

.mmp-legend-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: #063c6d;
  letter-spacing: 0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mmp-legend-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.mmp-legend-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  background: transparent;
  color: #063c6d;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.8rem;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.mmp-legend-btn:hover {
  background-color: rgba(6, 60, 109, 0.1);
}

.mmp-legend-btn--close:hover {
  background-color: rgba(220, 53, 69, 0.12);
  color: #dc3545;
}

.mmp-legend-body {
  flex: 1 1 auto;
  overflow: auto;
  padding: 8px;
  background: #ffffff;
}

.mmp-legend-body img {
  display: block;
  max-width: 100%;
}
</style>

<script>
export default {
  name: 'MMP_LayerLegend',
  props: [
    'layerLegendMaxHeight',
    'layerLegendName',
    'legendImgSrc',
    'legendMinimized'
  ],
  data() {
    return {
      height: 1,
      modifiedName: '',
      width: 1
    }
  },
  methods: {
    getDimensions() {
      let layerLegendImg = document.getElementById('imgLegend')
      let layerLegendModifiedName = document.getElementById('modifiedLayerName')
      let layerLegendClose = document.getElementById('closeLayerLegendElement')
      let layerLegendMinOrMax = document.getElementById('minOrMaxLayerLegendElement')
      let buttonsTotalWidth = layerLegendClose.clientWidth + layerLegendMinOrMax.clientWidth
      let nameWidth = layerLegendModifiedName.offsetWidth
      let totalHeaderWidth = nameWidth + buttonsTotalWidth + 40
      this.height = layerLegendImg.naturalHeight
      this.width = layerLegendImg.naturalWidth
      let aspectRatioWidthToUse =
        this.legendMinimized
          ? totalHeaderWidth
          : Math.max(totalHeaderWidth, this.width + buttonsTotalWidth)
      this.$emit('aspectRatio', {
        height: this.height,
        width: aspectRatioWidthToUse
      })
    },
    modifyNewLayerName(newLayerName) {
      return `${newLayerName.replace(/_/g, ' ')} Legend`
    }
  },
  mounted() {
    this.modifiedName = this.modifyNewLayerName(this.layerLegendName)
    this.$emit('initResize')
  },
  watch: {
    layerLegendName: function (newValue, oldValue) {
      this.modifiedName = this.modifyNewLayerName(newValue)
      this.getDimensions()
    },
    legendMinimized: function (newValue, oldValue) {
      this.getDimensions()
    }
  }
}
</script>
